(function (global, factory) {
	if (typeof define === "function" && define.amd) {
		define(["module"], factory);
	} else if (typeof exports !== "undefined") {
		factory(module);
	} else {
		var mod = {
			exports: {}
		};
		factory(mod);
		global.error = mod.exports;
	}
})(this, function (module) {
	"use strict";

	var _extends = Object.assign || function (target) {
		for (var i = 1; i < arguments.length; i++) {
			var source = arguments[i];

			for (var key in source) {
				if (Object.prototype.hasOwnProperty.call(source, key)) {
					target[key] = source[key];
				}
			}
		}

		return target;
	};

	class HTTPError extends Error {
		constructor(statusCode, statusText, message, extras) {
			super(message || statusText);
			if (arguments.length >= 4 && extras) {
				_extends(this, extras);
			}
			this.statusCode = statusCode;
			this.statusText = statusText;
		}
	}

	module.exports = HTTPError;
});
//# sourceMappingURL=error.js.map